import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { FormError } from 'common/components/layout';
import { updateReservationCart } from 'redux/reservationCart/actions';

import CustomerDisplay from './components/CustomerDisplay';
import Notes from './components/Notes';
import { validateCustomerLoggedIn } from './validators';

class CustomerLoggedIn extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateReservationCart(data, successFunction);
  };

  render() {
    const { reservationCart, customer, handleSubmit, form } = this.props;
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <CustomerDisplay customer={customer.data} />
        <Notes reservationCart={reservationCart} />

        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment method
          </button>
          <a href="/reservation/availability">Return to availability</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    notes: values.notes
  };

  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateCustomerLoggedIn(data);
  return errors;
};

const mapStateToProps = (state) => {
  const reservationCart = state.reservationCart.data;
  const initialValues = {
    notes: reservationCart.notes,
    isNotes: !!reservationCart.notes
  };

  return {
    customer: state.customer,
    initialValues
  };
};

CustomerLoggedIn = reduxForm({
  form: 'customerLoggedIn',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CustomerLoggedIn);

export default connect(mapStateToProps, {
  updateReservationCart
})(CustomerLoggedIn);
